<template>
  <div id="articles">
    <div class="article_box mainWidth">
      <div class="title">
        {{news.title}}
        </div>
      <div class="subbox">
        <p><span v-if="news.createtime">发布时间：{{news.createtime}}</span><span v-if="news.createtime">浏览人数：{{news.browsenumber}}</span></p>
      </div>
      <div class="contents" v-html="news.contents">

      </div>
      <mu-row gutter class="footer">
        <mu-col width="100" tablet="50" desktop="50">
          <div class="pre oneLine" v-show="news.beforetitle" @click="getArticle(news.beforeid)"><span>上一篇</span>{{news.beforetitle}}</div>
        </mu-col>
        <mu-col width="100" tablet="50" desktop="50">
          <div class="next oneLine" v-show="news.aftertitle"  @click="getArticle(news.afterid)"><span>下一篇</span>{{news.aftertitle}}</div>
        </mu-col>

      </mu-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'article',
    metaInfo() {
      return {
        title: this.news.title,
        meta: [{                 // set meta
          name: 'keyWords',
          content: '赛事新闻，射击比赛，省运会，全运会，奥运会，速得尔'
        }, {                 // set meta
          name: 'description',
          content: '速得尔专注射击运动，全面报道全国各级别射击比赛'
        }]
      }
    },
    data () {
      return {
        id:"",
        news:{}
      }
    },
    watch:{
      '$route.params.id':function(){
        this.id=this.$route.params.id;
        this.reqArticle();
      }
    },
    created(){
      this.id=this.$route.params.id||"1";
      this.reqArticle();
    },

    methods:{
      getArticle(id){ //跳转到列表详情
        this.$router.push({name:"article",params:{id:id}});
      },
      reqArticle(){ //请求文章
        this.$http({
          root:'http://www.supershooter.cn:8099/webapi/NewsDetails',
          method:'post',
          params:{
            newsid:this.id
          }
        }).then((res)=>{
          this.sw=true;
          console.log(res.body);
          if(res.body.code==200){
            this.news=res.body.data;
          }else{
            this.showErr(res);
          }
        },(res)=>{
          this.showErr(res);
        });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #articles{
    background-color: #E6E6E6;
    overflow:hidden;
    .article_box{
      margin-top:16px;
      margin-bottom:60px;
      background:#fff;
      padding:40px 80px;
      min-height:600px;
      .title{
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #3B3B3B;
        letter-spacing: 0;
        line-height:40px;
        text-align:center;
        padding:0px 5%;
        border-bottom:1px solid  #D8D8D8;
      }
      .subbox{
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #B5B5B5;
        letter-spacing: 0;
        line-height: 40px;
        text-align:center;
        span{
          padding:0px 20px;

        }
      }
      .footer{
        margin-top:60px;
        .pre,.next{
          width:100%;
          float:left;
          font-size: 14px;
          color: #3B3B3B;
          font-weight:600;
          letter-spacing: 0;
          line-height: 16px;
          cursor:pointer;
          transition:all 500ms;
          &:hover{
            color: #20A9F2;

          }
          >span{
            padding-right:20px;
          }

        }
      }
    }
  }

</style>
<style lang="less">
  #articles{
    .contents{
      strong{
        font-weight:600;
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/article.vue